// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__4E0lz","info":"Note_info__2nQ3r","note":"Note_note__36pt7","actions":"Note_actions__2qkE-"};